import { render, staticRenderFns } from "./todoApprove.vue?vue&type=template&id=8893a152&scoped=true&"
import script from "./todoApprove.vue?vue&type=script&lang=js&"
export * from "./todoApprove.vue?vue&type=script&lang=js&"
import style0 from "./todoApprove.vue?vue&type=style&index=0&id=8893a152&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8893a152",
  null
  
)

export default component.exports